var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#telegram_svg__clip0_11108_10179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 40c11.046 0 20-8.954 20-20s-8.954-20-20-20S.5 8.954.5 20s8.954 20 20 20z",
    fill: "url(#telegram_svg__paint0_linear_11108_10179)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.553 19.79c5.83-2.541 9.718-4.216 11.664-5.025 5.554-2.31 6.708-2.711 7.46-2.725.166-.002.536.039.775.233.203.164.258.386.285.542.027.155.06.51.033.787-.3 3.162-1.603 10.837-2.265 14.379-.28 1.499-.833 2.001-1.367 2.05-1.162.107-2.044-.767-3.169-1.505-1.76-1.154-2.754-1.872-4.463-2.998-1.975-1.301-.695-2.016.43-3.185.295-.306 5.413-4.96 5.512-5.383.012-.053.024-.25-.093-.353-.117-.104-.29-.069-.414-.04-.177.04-2.989 1.898-8.437 5.575-.798.549-1.52.816-2.168.802-.715-.016-2.088-.404-3.11-.736-1.252-.407-2.247-.622-2.16-1.314.044-.36.54-.728 1.487-1.105z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "telegram_svg__paint0_linear_11108_10179",
    x1: 20.5,
    y1: 0,
    x2: 20.5,
    y2: 39.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "telegram_svg__clip0_11108_10179"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h40v40H0z"
  })))));
}

export default SvgTelegram;